import { Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild} from "@angular/core";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import * as CONSTANT from '../../services/constants';
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from "@angular/common/http"
import { ImageUrls } from "src/app/services/s3buket";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { Lightbox } from "ngx-lightbox";

@Component({
  selector: "app-resume-overview",
  templateUrl: "./resume-overview.component.html",
  styleUrls: ["./resume-overview.component.css"]
})
export class ResumeOverviewComponent implements OnInit {
  modalRef?: BsModalRef;
  showError = false;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users
  profileImage:any;
  reviewForm:FormGroup;
  form:FormGroup;
  // vatern
  formVeteran:FormGroup;
  fileUploadV;
  serviceList:any=[];
  fileName: any;
  haveFileName: any;
  isAccept: boolean =false;
  fileSize: boolean =false;
  showOtherService: boolean =false;
	vetFileUpload;
  vetFileName: any;
  haveVeternFileName: any;
  // skillList
  skillform:FormGroup;
  show = false;
  skillList:any=[];  
  allSkills:any=[];  
  userQuestion: string = "";
  userQuestionUpdate = new Subject<string>();
  addedSkills:any=[];
  // detail info
  userData:any;
  resumeData:any;
  // work-exp
  workForm: FormGroup;
  // edit edu
  eduForm: FormGroup;
  showGPAError = false;
  // uni&spec
  allSpec:any=[];
  allUni:any=[];
  allEducationList:any=[];
  // datepicker
  minDate = new Date();
	maxDate = new Date();
	today: Date | undefined;
  title="Add";
  editId:any;
  datePipe: any;
  // vol
  volForm: FormGroup;
  allEmployee:any=[];
  //projects
  projectForm:FormGroup;
  addTeam:FormGroup;
  // team member
  memberEditingPosition=-1;
  showTeamMemberError:boolean=false;

  // awards
  awardList:any=[]; 
  fileUpload;
  thumbnailImage:any=[];
  //awardform
  awardform:FormGroup;
  //lic
  licForm:FormGroup;
  //langugae
  Languages:any=CONSTANT.Languages;
  langForm:FormGroup;
  // lightgallery
  _albums: any = [];
  mediaInfo = [];
  dropdownLanguageSettings:any;
  constructor(private modalService: BsModalService,private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService,private http: HttpClient, private handler: HttpBackend, private _lightbox: Lightbox, private _lightboxGallery: Lightbox) {
    this.form = this.formBuilder.group({
      scoreLink:  ["", Validators.compose([Validators.pattern(CONSTANT.URL_REGEX)])],
      phoneNumber: ["", Validators.compose([Validators.required])],
      countryCode: ["+1"],
      location: ["", Validators.compose([Validators.required])],
    });
    this.formVeteran = this.formBuilder.group({
      serviceId: ["", Validators.compose([Validators.required])],
      otherServiceTitle: [""],
      militaryJobTitle: ["", Validators.compose([Validators.required, Validators.minLength(3),Validators.maxLength(30)])],
      authenticityDocumentLink: [""],
      veteranRelationDocumentLink: [""],
      veteranRelationName: [""],
      userType: [""], 
    });
    this.skillform = this.formBuilder.group({
      skillIdsArray: ["", Validators.compose([Validators.required])],
    });
    this.workForm = this.formBuilder.group({
      id: [""],
      employementTypeId: [""],
      jobTitle: ["", Validators.compose([Validators.required])],
      companyName: ["", Validators.compose([Validators.required])],
      underContractOf: [""],
      fromDate: [""],
      toDate: [""],
      description: ["", Validators.compose([Validators.minLength(3),Validators.maxLength(250)])],
      location: [""],
      isCurrentlyRole: [""],
      // zipCode: [""],
      // latitude: [""],
      // longitude: [""],
    });
    this.eduForm = this.formBuilder.group({
      specializationId: ["", Validators.compose([Validators.required])],
      universityId: ["", Validators.compose([Validators.required])],
      fromDate: [""],
      toDate: [""],
      description: ["", Validators.compose([ Validators.minLength(3),Validators.maxLength(250)])],
      gpa: [""],
      isPursuing: [""],
    });
    this.volForm = this.formBuilder.group({
      employementTypeId: [""],
      organization: ["", Validators.compose([Validators.required])],
      fromDate: [""],
      toDate: [""],
      description: ["", Validators.compose([Validators.minLength(3),Validators.maxLength(250)])],
      role: ["", Validators.compose([Validators.required])],
      cause: [""],
      isCurrentlyRole: [""],
    });
    this.projectForm = this.formBuilder.group({
      associatedWith: [""],
      projectTitle: ["", Validators.compose([Validators.required,Validators.maxLength(50)])],
      location: [""],
      fromDate: [""],
      toDate: [""],
      isCurrentlyOngoing: [""],
      description: ["", Validators.compose([ Validators.minLength(3),Validators.maxLength(250)])],
      projectMembers:[""],
      projectLinks:[""],
      projectMedia:[""],
    });
    this.addTeam = this.formBuilder.group({
      name:["", Validators.compose([Validators.required])],
      email:["", Validators.compose([Validators.required,Validators.pattern(CONSTANT.EMAIL_REGEX)])],
    })
    this.licForm = this.formBuilder.group({
      name: ["", Validators.compose([Validators.required])],
      attestedByAuthority: ["", Validators.compose([Validators.required])],
      credentialUrl: [""],
      certificationNo: [""],
      issuesedOn: [""],
      expirydate: [""],
    });
    this.langForm = formBuilder.group({
      id:[""],
      language: ["", Validators.compose([Validators.required])],
      proficiency: ["", Validators.compose([Validators.required])],
    })
    this.awardform = this.formBuilder.group({
      name: ["", Validators.compose([Validators.required])],
      issuer: [""],
      issuesedOn: [""],
      associatedWith: [""],
      description: ["", Validators.compose([Validators.minLength(3),Validators.maxLength(250)])],
    });

    this.reviewForm =  this.formBuilder.group({
      isRequired:["", Validators.compose([Validators.required])],
    })
   }

  ngOnInit(): void {
    this.userQuestionUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        if(value == ""){
          this.skillList = [];
        } else{
          let params = new HttpParams(); 
        params = params.append("search", value);
        this.api.getData(apiUrl._searchSkills,params)
              .subscribe(async (res) => {
                this.skillList = [];
                res.data.skills.map((skill) => {
                  let alreadyAdded = false;
                  this.addedSkills.map((addedSkills)=> {
                    if (addedSkills.id == skill.id) {
                      alreadyAdded = true;
                    }
                  })
                  if (!alreadyAdded) {
                    this.skillList.push(skill);
                  }
                  this.show=true;
                })
                
          })
        }
        
      });
      this.scrollOnTop();
      this.getSkills();
      this.getServices();
    this.getUserDetail();
    this.getResumeDetail();
    this.getEmpType();
    
    this.dropdownLanguageSettings = {
			singleSelection: true,
			idField: "name",
			textField: "name",
			itemsShowLimit: 1,
			allowSearchFilter: true,
		};
  } 
  getUserDetail(){
    this.api.getDatas(apiUrl._getUserInfo)
    .subscribe(async (res) => { 
      this.userData = res.data;
      this.profileImage = this.userData.profileImage
     })
  }
  getResumeDetail(){
    this.api.getDatas(apiUrl._getResume)
    .subscribe(async (res) => {
      this.resumeData = res.data; 
      this.mediaInfo = [];
      this._albums = [];
      this.resumeData.projects.map( media =>{
        this.mediaInfo = media?.projectDocumentsDetails;
        for (let i = 0; i < media?.projectDocumentsDetails.length; i++) {
          const src = this.globalUrl + media?.projectDocumentsDetails[i].fileName;
          const album = {
            src: src,
          };
          this._albums.push(album);
        }
      })
     })
  }
  open(index: number): void {
    this._lightbox.open(this._albums, index);  
  }
  close(): void { // close lightbox programmatically 
    this._lightbox.close(); 
    } 
// project detail 
openProjectDetail(template: TemplateRef<any>) { 
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
  
}
// edit profile 
opneProfileModel(userData,template: TemplateRef<any>) { 
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-md addModal" })
  );
  setTimeout(() => {
    this.form.patchValue(userData)
  }, 500);
}
uploadImg(event) { 
  const files = event.target.files; 
   this.fileUpload = files[0];
  this.uploadFileToS3Image();
}

uploadFileToS3Image() {
  const data = {
    "directory":ImageUrls.directories.users,
    "fileName": this.fileUpload.name,
    "contentType": this.fileUpload.type
  } 
  this.api.postData(apiUrl._upload, data)
    .subscribe(res => {
      this.http = new HttpClient(this.handler);
      this.http.put<any>(res.data.uploadURL, this.fileUpload).subscribe(response => {
       this.form.value.profileImage=res.data.fileName;
       this.profileImage=res.data.fileName;
       this.form.patchValue({
        profileImage:res.data.fileName
       })
       
      })
    })
} 
  // submit from
  onSubmit(){
    this.form.value.countryCode= "+1"; 
    if(this.form.value.profileImage == "" || this.profileImage == ""){
      this.showError=true;
      setTimeout(() => {
        this.showError=false;
      }, 3000);
      return
    } 
    if(this.form.valid){
      this.api.putData(apiUrl._updateProfile, this.removeEmptyFiled(this.form))
      .subscribe(async (res) => {
        this.modalRef?.hide();
        this.getUserDetail();
        this.getResumeDetail();
        this.form.reset();
      })
    } else{
      this.showError=true;
      setTimeout(() => {
        this.showError=false;
      }, 3000);
    }
  }
  // get services
  
  getServices(){ 
    this.api.getDatas(apiUrl._commonServices)
      .subscribe(async (res) => {
        this.serviceList=res.data.listing;
         
      }, err => {
          this.toastrService.error("Error", err.error.message)
    })
  }
  selectedService(event){
    this.serviceList.map((uni)=>{ 
      if(event == uni.id && uni.name == "Other"){
        this.showOtherService = true;
      } else{this.showOtherService= false}
    })
  }
  uploadDoc(event) { 
    if(event.target.files[0].size > 500000 ){
      this.fileSize =true
      setTimeout(() => {
        this.fileSize= false
      }, 2000);
    }
    if(event.target.files[0].type.includes("image") && (event.target.files[0].name.split(".")[1] !="png" && event.target.files[0].name.split(".")[1] !="svg")   || event.target.files[0].type.includes("pdf")){
      const files = event.target.files; 
      this.fileUploadV = files[0];
      this.haveFileName =this.fileUploadV.name
      this.uploadFileToS3Doc();
    } else{
      this.showError= true
      setTimeout(() => {
        this.showError= false
      }, 2000);
      this.api.showErrorUpload("","Please upload only Jpg,Jpeg images & Pdf file")
    }
    
	}
	
	uploadFileToS3Doc() {
		const data = {
			"directory": this.globalUrl,
			"fileName": this.fileUploadV.name,
			"contentType": this.fileUploadV.type
		} 
    this.fileName=data.fileName;
		this.api.postData(apiUrl._upload, data)
			.subscribe(res => {
				this.http = new HttpClient(this.handler);
				this.http.put<any>(res.data.uploadURL, this.fileUploadV).subscribe(response => {
        this.haveFileName=res.data.fileName
        this.formVeteran.value.authenticityDocumentLink=res.data.fileName
				})
			})
	}
  // upload vetren dov

uploadVeteranDoc(event) { 
  if(event.target.files[0].size > 500000 ){
    this.fileSize =true
    setTimeout(() => {
      this.fileSize= false
    }, 2000);
  }
  if(event.target.files[0].type.includes("image") && (event.target.files[0].name.split(".")[1] !="png" && event.target.files[0].name.split(".")[1] !="svg")   || event.target.files[0].type.includes("pdf")){
    const files = event.target.files; 
    this.vetFileUpload = files[0];
    this.haveVeternFileName =this.vetFileUpload.name
    this.uploadVeternFileToS3();
  } else{
    this.showError= true
    setTimeout(() => {
      this.showError= false
    }, 2000);
    this.api.showErrorUpload("","Please upload only Jpg,Jpeg images & Pdf file")
  }
  
}
uploadVeternFileToS3() {
  const data = {
    "directory": this.globalUrl,
    "fileName": this.vetFileUpload.name,
    "contentType": this.vetFileUpload.type
  } 
  this.vetFileName=data.fileName;
  this.api.postData(apiUrl._upload, data)
    .subscribe(res => {
      this.http = new HttpClient(this.handler);
      this.http.put<any>(res.data.uploadURL, this.vetFileUpload).subscribe(response => {
      this.haveVeternFileName=res.data.fileName
      this.form.value.veteranRelationDocumentLink=res.data.fileName
      this.form.patchValue({
        veteranRelationDocumentLink:res.data.fileName
      })
      })
    })
}
  changeAccept(event) { 
    this.isAccept = event.target.checked
    if (event.target.checked == "1") {  
			this.isAccept = true
		} 
	}
  onSubmitDoc(){ 
    if (this.fileName == null) {
      this.showError = true
      setTimeout(() => {
        this.showError = false
      }, 3000)
      return;
    } 
    
    if (!this.haveVeternFileName && this.userData?.userType == 1) {
      this.showError = true
      setTimeout(() => {
        this.showError = false
      }, 3000)
      return;
    } 
    if(this.formVeteran.value.honorAwardArray ==""){
      delete this.formVeteran.value.honorAwardArray;
    }
    if(this.showOtherService == true && this.formVeteran.value.otherServiceTitle == ""){
      this.showError= true;
      return
    } else{
      this.showError=false
    }
    this.formVeteran.patchValue({
      authenticityDocumentLink:this.haveFileName,
      veteranRelationDocumentLink:this.haveVeternFileName,
      honorAwardArray:this.awardList,
      userType:this.userData.userType,
    })
    if (this.formVeteran.valid) { 
      this.api.putData(apiUrl._updateAuthDocumentV1, this.removeEmptyFiled(this.formVeteran))
        .subscribe(async (res) => { 
          this.toastrService.success("Document Uploaded successfully!"); 
          this.getUserDetail();
          this.modalRef?.hide()
        })
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 1000);
    }
  } 
// add edu
getUniSpec(){
  this.api.getDatas(apiUrl._allUniSpec)
  .subscribe(async (res) => {
    this.allSpec = res.data.specialization;
    this.allUni = res.data.universities;
  })
} 
// Veteran
opneVeteranModel(userData,template: TemplateRef<any>) {
  let data=userData.id 
  this.title = "Edit";

  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-md addModal" })
  );
  let serName:any=[];
  let serNameId;
  this.serviceList.map((ser)=>{
    if(ser.name == userData?.Services){ 
      serName.push(ser.id) 
      serNameId=ser.id;
    }
  })
  this.fileName=userData.authenticityDocumentLink,
  this.vetFileName=userData.veteranRelationDocumentLink,
  setTimeout(() => {
    this.formVeteran.patchValue({
      authenticityDocumentLink:userData.authenticityDocumentLink,
      veteranRelationDocumentLink:userData.veteranRelationDocumentLink,
      veteranRelationName:userData.veteranRelationName,
      serviceId:serNameId,
      otherServiceTitle:userData.otherServiceTitle,
      militaryJobTitle:userData.militaryJobTitle,
    })
  }, 500);
}
// skills
opneSkillModel(template: TemplateRef<any>) { 
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
}
search() {
  this.userQuestionUpdate.next(this.userQuestion)
}
drop(){
  this.show=false;
}
selectedSkill(i){
  this.addedSkills.push(this.skillList[i])
  this.skillList.splice(i,1) 
}
removeSkills(i){
  this.addedSkills.splice(i,1)
}
// get skills
getSkills(){
  this.api.getDatas(apiUrl._getSkill)
  .subscribe(async (res) => {
    res.data.map((skill) => {
      this.addedSkills.push(skill.skillDetails);
    })
  })
}

onSubmitSkill(){
  let skillIds:any=[];
  this.addedSkills.map((skill)=>{
    skillIds.push({"skillId":skill.id})
  })
  this.skillform.patchValue({
    skillIdsArray: skillIds
  })

  if(this.skillform.valid && this.addedSkills.length <= 10){
    this.api.putData(apiUrl._updateSkill, this.skillform.value)
    .subscribe(async (res) => {
      this.toastrService.success("", "Skills Added Successfully!");
      this.modalRef?.hide();
      this.getResumeDetail();
        this.skillform.reset();
    })
  } else{
    this.showError=true;
    setTimeout(() => {
      this.showError=false;
    }, 3000);
  }
  
}
// work exp model
openWorkModal(template: TemplateRef<any>) { 
  this.workForm.reset()
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
}
 // selected employee
 onSelectedEmployment(i,event){
  this.allEmployee.map((emp)=>{
    emp["selected"] = false
    event.srcElement.classList.remove("selected")
  })
  this.allEmployee[i]["selected"] = true
  event.srcElement.classList.add("selected")
}
// on submit
onWorkSubmit(){ 
  let employeeType = ""
  this.allEmployee.map((employee) => {
    if(employee["selected"] == true) {
      if (employeeType == "") {
        employeeType = employee.id
      } else {
        employeeType = employeeType + "," + employee.id
      }
    }
  })
  this.workForm.value.employementTypeId =employeeType;
  this.workForm.patchValue({
    employementTypeId:employeeType
  })
  if(this.workForm.value.isCurrentlyRole == 1 || this.workForm.value.isCurrentlyRole == true){
    this.workForm.patchValue({
      isCurrentlyRole : 1
    })
  }
  if(this.workForm.value.underContractOf == ""){
    delete this.workForm.value.underContractOf;
  }
  if(this.workForm.valid){
    this.api.postData(apiUrl._addWorkExp, this.removeEmptyFiled(this.workForm) )
    .subscribe(async (res) => {
      this.toastrService.success("", "Work Experience Added Successfully!");
      this.modalRef?.hide();
      this.getResumeDetail();
        this.workForm.reset();
    })
  } else{
    this.showError= true;
    setTimeout(() => {
      this.showError= false;
    }, 2500);
  }
  
}
editWork(work,template: TemplateRef<any>){
  this.editId =work;
  this.title ="Edit"
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
  setTimeout(() => {
    this.workForm.patchValue(work)
  }, 500);
}
// education model
openEduModal(template: TemplateRef<any>) { 
  this.getUniSpec();
  this.eduForm.reset();
  this.title ="Add"
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
} 
// on submit
onEduSubmit(){
  if(this.eduForm.value.isPursuing == 1 || this.eduForm.value.isPursuing == true){
    this.eduForm.patchValue({
      isPursuing : 1
    })
  }
  
  if(this.eduForm.value.gpa > 10 && this.eduForm.value.gpa >= 0){
    this.showGPAError= true;
    setTimeout(() => {
      this.showGPAError= false;
    }, 2500);
    return
  } else{
    this.showGPAError = false
  }
  if(this.eduForm.valid){
    if(this.editId){
      this.api.putData(apiUrl._updateEdu,  this.removeEmptyFiled(this.eduForm))
      .subscribe(async (res) => {
        this.toastrService.success("", "Education Added Successfully!");
        this.getResumeDetail();
        this.modalRef?.hide();
        this.eduForm.reset();
      })
    } else{
      delete this.eduForm.value.id;
      this.api.postData(apiUrl._addEdu, this.removeEmptyFiled(this.eduForm))
      .subscribe(async (res) => {
        this.toastrService.success("", "Education Added Successfully!");
        this.getResumeDetail();
        this.modalRef?.hide();
      })
    }
  } else{
    this.showError= true;
    setTimeout(() => {
      this.showError= false;
    }, 2500);
  }
  
}
  // edit
  editEdu(edu,template: TemplateRef<any>){
    this.getUniSpec();
    this.editId =edu;
    this.title ="Edit"
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
    setTimeout(() => {
      this.eduForm.patchValue(edu)
    }, 500);
  }
// volunterring
getEmpType(){
    this.api.getDatas(apiUrl._allEmpType)
    .subscribe(async (res) => {
      this.allEmployee = res.data.listing;
    })
}
  // selected employee
  selectedEmployment(i,event){
    this.allEmployee.map((emp)=>{
      emp["selected"] = false
      event.srcElement.classList.remove("selected")
    })
    this.allEmployee[i]["selected"] = true
    event.srcElement.classList.add("selected")
  }
openVolModal(template: TemplateRef<any>) {
  this.getEmpType()
  this.volForm.reset();
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
}
 // edit
 editVol(data,template: TemplateRef<any>){
  this.getEmpType()
  this.editId =data.id;
  this.title ="Edit"
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
  setTimeout(() => {
    this.allEmployee = data.employementTypeDetails
    this.volForm.patchValue({
      ...data,
      fromDate:new Date(data.fromDate),
      toDate:new Date(data.toDate),
    })
  }, 500);
}
// on submit
onVolSubmit(){
  let employeeType = ""
  this.allEmployee.map((employee) => {
    if(employee["selected"] == true) {
      if (employeeType == "") {
        employeeType = employee.id
      } else {
        employeeType = employeeType + "," + employee.id
      }
    }
  })
  this.volForm.value.employementTypeId =employeeType;
  this.volForm.patchValue({
    employementTypeId:employeeType
  })
  if(this.volForm.value.isCurrentlyRole == 1 || this.volForm.value.isCurrentlyRole == true){
    this.volForm.patchValue({
      isCurrentlyRole : 1
    })
  }
  if(this.volForm.valid){
    if(this.editId){
      this.api.putData(apiUrl._updateVolExp, this.removeEmptyFiled(this.volForm))
        .subscribe(async (res) => {
          this.toastrService.success("", "Volunteer Experience Edit Successfully!");
          this.getResumeDetail();
          this.modalRef?.hide()
          this.volForm.reset();
      })
    } else{
      delete this.volForm.value.id;
        this.api.postData(apiUrl._addVolExp, this.removeEmptyFiled(this.volForm))
        .subscribe(async (res) => {
          this.toastrService.success("", "Volunteer Experience Added Successfully!");
          this.getResumeDetail();
          this.modalRef?.hide()
          this.volForm.reset();
      })
    }
    
  } else{
    this.showError= true;
    setTimeout(() => {
      this.showError= false;
    }, 2500);
  }
  
}
// projects
openProjectModal(template: TemplateRef<any>) { 
  this.projectForm.reset()
  this.addTeam.reset()
  this.awardList=[]
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
} 
openTeamModal(template: TemplateRef<any>) {
  this.title="Add";
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
}

closeModal(){
 this.modalService.hide();
 this.addTeam.reset();
 this.memberEditingPosition = -1;
}
closeAddModal(){
  this.projectForm.reset()
  this.modalService.hide();
 }
// add team member
onAddTeam(){
  if(this.addTeam.valid){
    let members = this.projectForm.value.projectMembers;

    if (this.memberEditingPosition == -1) {
      if (members == "") {
        members = [];
      }
      members.push({
        name: this.addTeam.value.name,
        email: this.addTeam.value.email
      });
    } else {
      members[this.memberEditingPosition] = {
        name: this.addTeam.value.name,
        email: this.addTeam.value.email
      }
      this.memberEditingPosition = -1;
    }
  
    this.projectForm.patchValue({
      projectMembers: members
    }) 
    
    this.modalRef?.hide()
    this.addTeam.reset();
  } else{
    this.showTeamMemberError=true;
    setTimeout(() => {
      this.showTeamMemberError=false
    }, 2000);
  }
}
editMember(i,template: TemplateRef<any>){
  this.title="Edit";
  this.memberEditingPosition=i
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
  setTimeout(() => {
    this.addTeam.patchValue(this.projectForm.value.projectMembers[i])
  }, 200);
}
deleteMember(i){
  let members = this.projectForm.value.projectMembers;
  members.splice(i,1)
  this.projectForm.patchValue({
    projectMembers: members
  })
}
// add awards
addHonors(name){
  if(name !== null){
    this.awardList.push({name, orderByIndex: this.awardList.length + 1});
  }
  let awardName : any = []
  this.awardList.map((awards) => { 
    awardName.push(awards.name);
  }) 
  this.projectForm.patchValue({
    projectLinks :awardName
  })
}
deleteHonors(name) {
  const index = this.awardList.indexOf(name);
  if( index >= 0) this.awardList.splice(index, 1);
} 
// image upload
upload(event) { 
  const files = event.target.files; 
   this.fileUpload = files[0];
  this.uploadFileToS3();
}

uploadFileToS3() {
  const data = {
    "directory":ImageUrls.directories.users,
    "fileName": this.fileUpload.name,
    "contentType": this.fileUpload.type
  } 
  this.api.postData(apiUrl._upload, data)
    .subscribe(res => {
      this.http = new HttpClient(this.handler);
      this.http.put<any>(res.data.uploadURL, this.fileUpload).subscribe(response => {
       this.thumbnailImage.push({ name:this.fileUpload.name,fileName:res.data.fileName})
       this.projectForm.patchValue({
        projectMedia:this.thumbnailImage
       })
      })
    })
} 
// 
deleteImage(i){
  this.thumbnailImage.splice(i,1);
  this.projectForm.patchValue({
    projectMedia:this.thumbnailImage
   })
}
// on submit
onProjectSubmit(){ 
  if(this.projectForm.value.isCurrentlyOngoing == 1 || this.projectForm.value.isCurrentlyOngoing == true){
    this.projectForm.patchValue({
      isCurrentlyOngoing : 1
    })
  }
  if(this.projectForm.valid){
    if(this.editId){
      this.api.putData(apiUrl._updateProjects, this.removeEmptyFiled(this.projectForm))
      .subscribe(async (res) => {
        this.toastrService.success("", "Education Added Successfully!");
        this.getResumeDetail();
        this.modalRef?.hide();
        this.projectForm.reset()
      })
    } else{
      this.api.postData(apiUrl._addProjects, this.removeEmptyFiled(this.projectForm))
      .subscribe(async (res) => {
        this.toastrService.success("", "Projects Added Successfully!");
      this.modalService.hide();
      this.getResumeDetail()
      this.projectForm.reset()
    })
    }
    
  } else{
    this.showError= true;
    setTimeout(() => {
      this.showError= false;
    }, 2500);
  }
  
}
// edit
editProject(project,template: TemplateRef<any>){
  this.editId =project.id;
  this.title ="Edit"
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
 
  
  setTimeout(() => {
    this.awardList = project.projectLinksDetails
    this.thumbnailImage = project.projectDocumentsDetails 
    this.projectForm.patchValue({
      ...project,
      fromDate: new Date(project.fromDate),
      toDate: new Date(project.toDate),
      projectMembers:project.projectTeamMembersDetails, 
    })
  }, 500);
}
// awards
openModal(template: TemplateRef<any>) { 
  this.awardform.reset();
  this.title ="Add"
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
}
editAward(award,template: TemplateRef<any>){
  this.editId =award.id;
  this.title ="Edit"
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
  setTimeout(() => {
    this.awardform.patchValue(award)
  }, 500);
}
onAwardSubmit(){
  if(this.awardform.valid){
    if(this.editId){
      this.awardform.patchValue({
        id :this.editId
       })
      this.api.putData(apiUrl._updateAwards, this.removeEmptyFiled(this.awardform))
      .subscribe(async (res) => {
        this.toastrService.success("", "Awards & honors Upated Successfully!");
        this.getResumeDetail();
        this.modalRef?.hide()
        this.awardform.reset();
      })
    } else{
      this.api.postData(apiUrl._addAwards, this.removeEmptyFiled(this.awardform))
      .subscribe(async (res) => {
        this.toastrService.success("", "Awards & honors Added Successfully!");
        this.getResumeDetail();
        this.modalRef?.hide()
        this.awardform.reset();
      })
    }
  } else{
    this.showError= true;
    setTimeout(() => {
      this.showError= false;
    }, 2500);
  }
}
//language
openLangModel(template: TemplateRef<any>) {
  this.getEmpType()
    this.editId ="";
    this.title ="Add"
    this.langForm.reset();
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
}

editLang(template: TemplateRef<any>,lang) {
  this.editId =lang.id;
  this.title ="Edit" 
  this.getEmpType()
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
  let patchFormValue = {
    ...lang,
    language: [{name: lang.language}]
  }
  this.langForm.patchValue(patchFormValue)
}
// on submit
onLangSubmit(){ 
  if(this.langForm.valid){  
    let data = this.removeEmptyFiled(this.langForm);
    data['language'] = data['language'][0].name
    if(this.editId){
      this.api.putData(apiUrl._updateLanguage, this.removeEmptyFiled(this.langForm))
      .subscribe(async (res) => {
        this.toastrService.success("", "Language Upated Successfully!");
        this.getResumeDetail();
        this.modalRef?.hide()
      })
    } else{
      this.api.postData(apiUrl._addLanguage, this.removeEmptyFiled(this.langForm))
      .subscribe(async (res) => {
        this.toastrService.success("", "Language Added Successfully!");
        this.getResumeDetail();
        this.modalRef?.hide()
        this.langForm.reset();
      })
    }
  } else{
    this.showError= true;
    setTimeout(() => {
      this.showError= false;
    }, 2500);
  }
}
//licence 
editLic(data,template: TemplateRef<any>){
  this.editId =data.id;
  this.title ="Edit"
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
  setTimeout(() => {
    this.licForm.patchValue(data)
  }, 500);
}
openLicModel(template: TemplateRef<any>) {
  this.getEmpType()
  this.licForm.reset();
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "modal-lg addModal" })
  );
}
// on submit
onLicSubmit(){ 
  if(this.licForm.valid){  
    this.api.postData(apiUrl._addLanguage, this.removeEmptyFiled(this.licForm))
    .subscribe(async (res) => {
      this.toastrService.success("", "Language Added Successfully!");
      this.getResumeDetail();
      this.modalRef?.hide()
      this.licForm.reset();
    })
  } else{
    this.showError= true;
    setTimeout(() => {
      this.showError= false;
    }, 2500);
  }
  
}
// on Launch profile
onLaunchProfile(){
  if(this.reviewForm.value.isRequired ==0 || this.reviewForm.value.isRequired ==""){
    this.showError = true;
    setTimeout(() => {
      this.showError = false;
    }, 2000);
    return
  }
  if(this.reviewForm.valid){
    this.router.navigate(["/dashboard-job"]);
  } else{
    this.showError = true;
    setTimeout(() => {
      this.showError = false;
    }, 2000);
  }
}
  // smoth scroll
  public scrollToElement(element): void {
    element.scrollIntoView({
      behavior: "smooth", 
      block: "end", 
      inline: "nearest"
    });
  }
  
removeEmptyFiled(form){
  const formValues = form.value;
  const formKeys = Object.keys(formValues);
  if (formKeys.length) {
    for (let i = 0; i < formKeys.length; i++) {
      if (
        formValues[formKeys[i]] == null ||
        formValues[formKeys[i]] == undefined ||
        formValues[formKeys[i]] == ""
      ) {
        delete formValues[formKeys[i]];
      }
    }
  }

  return formValues
}
 // check if only number
 preventNumbers(event): boolean { 
  event = (event) ? event : window.event;
  var charCode = (event.which) ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
  }
  return true;
}

isDisabled(event:any){
  if(event.target.checked) {
    this.eduForm.controls['toDate'].disable();
  } else {
    this.eduForm.controls['toDate'].enable();
  }
}
  // dateago
  dateAgo(fromDate:any,toDate:any) {
    if(fromDate != null && toDate != null){
      var startDate:any = new Date(fromDate);
      var endDate:any = new Date(toDate);
      var diffDate:any = new Date(endDate - startDate);
      return ((diffDate.toISOString().slice(0, 4) - 1970) + " years " + diffDate.getMonth() + " months ");
    }else {
      return "NA"
    }
  }
  scrollOnTop(){
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }
  workShow(value){
    console.log(value)
    if(value!='' && value!=undefined && value!=null){
     return  value.replaceAll(',',', ')
    }
    return '-'
  }
}
